module.exports = __webpack_public_path__ + "04_glasses_brown.27b73184.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer4/04_glasses_brown.png
// module id = PjuN
// module chunks = 0